import { useEffect, useState } from "react";
import * as styled from "./TeacherInfo.styled.jsx";
import { getTeacherInfo } from "../../../helpers/getTeacherInfo.js";
import { useParams, useNavigate } from "react-router-dom";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle.jsx";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled.jsx";
import axios from "../../../axios";
import RescheduleTeacherBlock from "../../../components/RescheduleTeacherBlock/RescheduleTeacherBlock.jsx";
import { getWeekStartDate } from "../../../helpers/weekUtils.js";


function TeacherInfo() {
  const [teacher, setTeachers] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();
  const [reschedules, setReschedules] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isRemove, setIsRemove] = useState(false);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [rescheduleSubmited, setRescheduleSubmited] = useState(false);
  const [currentWeek, setCurrentWeek] = useState(getWeekStartDate());
  // Пізні відмітки: відмітити урок можна протягом 24 год; якщо вчитель не встиг — адмін відкриває доступ
  const [lateUntil, setLateUntil] = useState(null);
  useEffect(() => { setLateUntil(teacher?.lateMarkUntil || null); }, [teacher?.lateMarkUntil]);
  const lateOpen = Boolean(lateUntil && new Date(lateUntil) > new Date());
  const setLateMarks = (hours) => {
    axios.patch(`admin/teachers/${id}/late-marks`, { hours })
      .then((res) => setLateUntil(res.data.lateMarkUntil))
      .catch(() => alert("Не вдалося змінити доступ"));
  };
  // Доступ до кабінету і матеріалів + коли вчитель востаннє був на платформі
  const [activity, setActivity] = useState(null);
  const [confirmBlock, setConfirmBlock] = useState(false);
  useEffect(() => {
    if (!id) return;
    axios.get(`admin/teachers/${id}/activity`).then((res) => setActivity(res.data)).catch(() => setActivity(null));
  }, [id]);
  const setAccess = (blocked) => {
    axios.patch(`admin/teachers/${id}/access`, { blocked })
      .then((res) => { setActivity((a) => ({ ...a, ...res.data })); setConfirmBlock(false); })
      .catch(() => alert("Не вдалося змінити доступ"));
  };
  const when = (d) => new Date(d).toLocaleString("uk-UA", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  const logins30 = (activity?.logins || []).filter((d) => Date.now() - new Date(d) < 30 * 864e5);
  // Стаж у школі: дата додавання на платформу (createdAt; для старих записів — час із _id)
  const addedAt = teacher?.createdAt
    ? new Date(teacher.createdAt)
    : teacher?._id ? new Date(parseInt(String(teacher._id).slice(0, 8), 16) * 1000) : null;
  const tenure = (from) => {
    const now = new Date();
    let months = (now.getFullYear() - from.getFullYear()) * 12 + now.getMonth() - from.getMonth();
    if (now.getDate() < from.getDate()) months -= 1;
    const anchor = new Date(from.getFullYear(), from.getMonth() + months, from.getDate());
    const days = Math.max(0, Math.floor((now - anchor) / 864e5));
    const parts = [];
    if (months >= 12) parts.push(`${Math.floor(months / 12)} р.`);
    if (months % 12) parts.push(`${months % 12} міс.`);
    if (days || !parts.length) parts.push(`${days} дн.`);
    return parts.join(" ");
  };
  useEffect(() => {
    if (!id) return;
    
    const weekStart = new Date(currentWeek);
    weekStart.setHours(0, 0, 0, 0);
    
    axios.get(`lesson-reschedule/${id}?weekStartDate=${weekStart.toISOString()}`)
      .then((res) => setReschedules(res.data.lesson))
      .catch((err) => console.error(err));
  }, [id, currentWeek]);

  useEffect(() => {
    getTeacherInfo(id).then((data) => setTeachers(data));
  }, [id]);
  
  
  

  useEffect(() => {
    if(!id) return
    setReschedules([])
    const weekStart = new Date(currentWeek);
    weekStart.setHours(0, 0, 0, 0);
    axios.get(`lesson-reschedule/${id}?weekStartDate=${weekStart.toISOString()}`)
    .then((res) => {
      console.log(res.data.lesson)
      setReschedules(res.data.lesson);
      if (rescheduleSubmited) setRescheduleSubmited(false); 
    })
    .catch(err => console.error(err))
  },[rescheduleSubmited, id, currentWeek])

  if (Object.keys(teacher).length === 0) return;

  const studentClickId = (ageGroup, id) => {
    navigate(`/admin/ourstudents/${ageGroup}/${id}`);
  };
  const handleRemove = (id) => {
    axios
      .delete(`teachers/${id}`)
      .then(() => {
        navigate("/admin/ourteachers");
      })
      .catch((err) => console.error(err));
  };
  
  const handleCloseModal = () => {
    setSelectedLesson(null);
    setRescheduleModal(false)
  };
 const handleSchedule = () => {
  if(isOpen) {
    setCurrentWeek(getWeekStartDate())
  }
  setIsOpen((prev) => !prev)
 }

  return (
    <PagesWrapper>
      <TopPageTitle value={teacher.name} />
      <styled.List>
        <styled.Item>
          <styled.ItemTitle>
            Ім’я: {teacher.name} - id:{teacher.teacherId}
          </styled.ItemTitle>
        </styled.Item>
        <styled.Item>
          <styled.ItemTitle>
            Номер телефону: {teacher.phoneNumber}
          </styled.ItemTitle>
        </styled.Item>
        {addedAt && (
          <styled.Item>
            <styled.ItemTitle>
              У школі з {addedAt.toLocaleDateString("uk-UA", { day: "numeric", month: "long", year: "numeric" })} — вже {tenure(addedAt)}
            </styled.ItemTitle>
          </styled.Item>
        )}
        <styled.Item>
          <styled.ItemTitle>
            Пізні відмітки уроків:{" "}
            {lateOpen
              ? `відкриті до ${new Date(lateUntil).toLocaleString("uk-UA", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}`
              : "закриті (відмітка — протягом 24 год після уроку)"}
          </styled.ItemTitle>
          <styled.OpenBtn style={{ marginTop: 8 }} onClick={() => setLateMarks(lateOpen ? 0 : 24)}>
            {lateOpen ? "Закрити пізні відмітки" : "Дозволити пізні відмітки на 24 год"}
          </styled.OpenBtn>
        </styled.Item>
        {activity && (
          <styled.Item>
            <styled.ItemTitle>
              Доступ до кабінету і матеріалів:{" "}
              {activity.accessBlocked
                ? `🔒 закрито${activity.accessBlockedAt ? ` з ${when(activity.accessBlockedAt)}` : ""}`
                : "відкрито"}
            </styled.ItemTitle>
            <styled.ItemTitle style={{ fontWeight: 400, fontSize: "0.95em" }}>
              Остання активність: {activity.lastSeenAt ? when(activity.lastSeenAt) : "ще не записано (облік з 27.10.2026)"}
              <br />
              Входів за 30 днів: {logins30.length}
              {logins30.length > 0 && ` (останній ${when(logins30[0])})`}
            </styled.ItemTitle>
            {activity.accessBlocked ? (
              <styled.OpenBtn style={{ marginTop: 8 }} onClick={() => setAccess(false)}>Відкрити доступ</styled.OpenBtn>
            ) : (
              <styled.RemoveWrapper style={{ marginTop: 8 }}>
                <styled.RemoveBtn onClick={() => setConfirmBlock((v) => !v)}>Закрити доступ</styled.RemoveBtn>
                {confirmBlock && (
                  <styled.Submit onClick={() => setAccess(true)}>
                    Підтвердити: вчителя одразу викине з кабінету, увійти не зможе
                  </styled.Submit>
                )}
              </styled.RemoveWrapper>
            )}
          </styled.Item>
        )}
        <styled.Item>
          <styled.ItemTitle>Студенти:</styled.ItemTitle>
          <styled.List>
            {teacher?.students?.map(({ name, studentId, _id, ageGroup }) => (
              <styled.StudentItem
                key={studentId}
                onClick={() => studentClickId(ageGroup, _id)}
              >
                <styled.ItemStudentTitle>
                  Ім’я: {name} - id:{studentId}
                </styled.ItemStudentTitle>
              </styled.StudentItem>
            ))}
          </styled.List>
        </styled.Item>
        <styled.BtnWrapper>
          <styled.OpenBtn onClick={handleSchedule}>
            Переглянути розклад
          </styled.OpenBtn>

          <styled.RemoveWrapper>
            <styled.RemoveBtn onClick={() => setIsRemove(prev => !prev)}>
            Видалити вчителя
            </styled.RemoveBtn>
            {isRemove &&  <styled.Submit onClick={() => handleRemove(id)}>Натисніть для підтвердження видалення</styled.Submit>}
          </styled.RemoveWrapper>
          
        </styled.BtnWrapper>
        
        {isOpen && (
           <RescheduleTeacherBlock currentWeek={currentWeek} setCurrentWeek={setCurrentWeek} isAdmin teacher={teacher} reschedules={reschedules} handleCloseModal={handleCloseModal} joinedLesson={''} setRescheduleSubmited={setRescheduleSubmited} selectedLesson={selectedLesson} setSelectedLesson={setSelectedLesson} rescheduleModal={rescheduleModal} setRescheduleModal={setRescheduleModal} setReschedules={setReschedules}/>
        )}
        
      </styled.List>
    </PagesWrapper>
  );
}

export default TeacherInfo;